import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 更新時期 */
enum UpdatePeriod {
  /** 遡り */
  retroactive = '1',
  /** 当月 */
  current = '2',
  /** 先行 */
  leading = '3',
}

const nameConfig = {
  retroactive: new Map([
    [Locale.ja, '遡り'],
    [Locale.en, 'Retroactive'],
  ]),
  current: new Map([
    [Locale.ja, '当月'],
    [Locale.en, 'Current Month'],
  ]),
  leading: new Map([
    [Locale.ja, '先行'],
    [Locale.en, 'Leading'],
  ]),
};

const toEnum = rawValueToEnum(UpdatePeriod, UpdatePeriod.current);
const toDisplay = enumToName(UpdatePeriod, nameConfig);

export const updatePeriod = {
  enum: UpdatePeriod,
  nameConfig,
  toEnum,
  toDisplay,
};
export type { UpdatePeriod };
